import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-input" }
const _hoisted_2 = { for: "input-field" }
const _hoisted_3 = ["placeholder"]

import { useKeyboardStore } from '@/stores/keyboardStore';
import { useUserStore } from '@/stores/userStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
  labelName: String,
  placeHolder: String,
  onEnter: Function
},
  setup(__props) {

const props = __props;

const keyboardStore = useKeyboardStore();

function scrollPrimaryButtonToBottom() {
  keyboardStore.setExpanded(true);
}

function handleBlur() {
  keyboardStore.setExpanded(false);
}

const userStore = useUserStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(props.labelName), 1),
    _withDirectives(_createElementVNode("input", {
      type: "input",
      id: "input-field",
      placeholder: props.placeHolder,
      maxlength: "32",
      autofocus: "",
      onBlur: handleBlur,
      onClick: scrollPrimaryButtonToBottom,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userStore).name) = $event)),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (props.onEnter && props.onEnter(...args)), ["prevent"]), ["enter"]))
    }, null, 40, _hoisted_3), [
      [
        _vModelText,
        _unref(userStore).name,
        void 0,
        { trim: true }
      ]
    ])
  ]))
}
}

})